import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { TagModule } from 'primeng/tag';

// 汎用在庫インターフェース（BicStock, KojimaStock, AeonStock共通）
export interface StoreStock {
  prefecture: string;
  area?: string;
  storeName: string;
  hasStock: boolean;
  stockMark?: string;
  stockValue?: string;
  note?: string;
}

@Component({
  selector: 'app-store-stock',
  templateUrl: './store-stock.component.html',
  styleUrls: ['./store-stock.component.sass'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TagModule],
})
export class StoreStockComponent implements OnInit {
  @Input() stocks: StoreStock[];

  removeTargets = ['コジマ×ビックカメラ', 'ビックカメラ', 'Air BicCamera'];

  constructor() {}

  ngOnInit(): void {}

  getStyle(hasStock: boolean): any {
    if (hasStock) {
      return null;
    } else {
      return {
        background: 'gray',
      };
    }
  }

  // 名前から "ビックカメラ " と "Air BicCamera " を削除する
  getStoreName(name: string): string {
    this.removeTargets.forEach((target) => {
      name = name.replace(target, '');
    });
    return name.trim();
  }

  // 在庫表示: stockMark (ビックカメラ/コジマ) または stockValue (イオン) を表示
  getStockDisplay(stock: StoreStock): string {
    const mark = stock.stockMark || stock.stockValue || '';
    const note = stock.note || '';
    return `${mark} ${note}`.trim();
  }
}
